import moment from 'moment'
import { TX_GRID_SORT_CREATED } from '../actions/tx_grid_sort'
import { addToSearch } from './helpers'

export const SORT_WINDOW_DEFAULT_DAYS = 90
export const SORT_WINDOW_MAX_DAYS = 365

export const RANGE_DEFAULT = 'default'
export const RANGE_CLAMPED = 'clamped'

const API_DATE_FORMAT = 'YYYY-MM-DD'

export const needsSortWindow = (sortField) => Boolean(sortField) && sortField.replace(/^-/, '') !== TX_GRID_SORT_CREATED

export const todayUtc = (now = moment.utc()) => moment.utc(now).format(API_DATE_FORMAT)

const daysEndingOn = (endDate, days) => ({
  startDate: moment
    .utc(endDate)
    .subtract(days - 1, 'days')
    .format(API_DATE_FORMAT),
  endDate,
})

export const sortWindowRange = (now = moment.utc()) => daysEndingOn(todayUtc(now), SORT_WINDOW_DEFAULT_DAYS)

const rangeDays = ({ startDate, endDate }) => moment.utc(endDate).diff(moment.utc(startDate), 'days') + 1

export const resolveSortRange = (sortField, range) => {
  if (!needsSortWindow(sortField)) {
    return { range, adjustment: null }
  }
  if (!range) {
    return { range: sortWindowRange(), adjustment: RANGE_DEFAULT }
  }
  if (rangeDays(range) > SORT_WINDOW_MAX_DAYS) {
    return { range: daysEndingOn(range.endDate, SORT_WINDOW_MAX_DAYS), adjustment: RANGE_CLAMPED }
  }
  return { range, adjustment: null }
}

export const dateRangeParams = (sortField, range) => {
  const resolved = resolveSortRange(sortField, range).range
  return resolved ? { start_date: resolved.startDate, end_date: resolved.endDate } : {}
}

export const rangeFromParams = ({ start_date, end_date, created_on } = {}) => {
  if (start_date && end_date) {
    return { startDate: start_date, endDate: end_date }
  }
  if (created_on) {
    return { startDate: created_on, endDate: created_on }
  }
  return null
}

export const addRangeToSearch = (search, range) =>
  range ? addToSearch(addToSearch(search, `start_date=${range.startDate}`), `end_date=${range.endDate}`) : search
